import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  width: calc(100% - 30px);
  padding: 0 15px 0 15px;
`;
